// extracted by mini-css-extract-plugin
module.exports = {"card":"SelectorCard_card__ggqAM","indicator":"SelectorCard_indicator__osZ3S","indicatorActive":"SelectorCard_indicatorActive__K6vHu"};